import request from '@/utils/request'

export function getMenus (params) {
  return request({
    // url: `/hyoa/a/sys/user/userMenus`,  // 测试
    url: `/hanyang-oa/a/sys/user/userMenus`, // 生产
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/userMenus.js